/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-07-02 17:53:42
 *
 *******************************************************/
//@flow

import React, { Component } from 'react';
import { Card, TextContainer, Button } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { connect } from 'react-redux';

import withBlockCanDismiss from './blockCanDismiss';

type Props = {
  renderPopover: () => void
};

type ComposedProps = Props & WithI18nProps;
class GettingStartedVideos extends Component<ComposedProps> {
  render() {
    const { renderPopover, i18n } = this.props;
    return (
      <Card>
        <Card.Header
          title={i18n.translate('AdminHTML.Dashboard.GettingStartedVideos.cardHeader_Title')}>
          <div className="BC-Block-Dismiss--Right-Menu">{renderPopover()}</div>
        </Card.Header>
        <Card.Section>
          <TextContainer>
            <p className="BC-Paragraph__Dashboard">
              {i18n.translate('AdminHTML.Dashboard.GettingStartedVideos.paragraph_Content')}{' '}
              <Button
                plain
                external
                url="https://help.boostcommerce.net">
                {i18n.translate('AdminHTML.Dashboard.GettingStartedVideos.textStyled_Children')}
              </Button>
            </p>
            <div className="BC-Iframe-Container__Wrapper">
              <div className="BC-Iframe-Container__Center">
                <div className="BC-Iframe-Container">
                  <iframe
                    title={i18n.translate('AdminHTML.Dashboard.GettingStartedVideos.iframeTitle')}
                    src="https://www.youtube.com/embed/Z35Gg4vYtH8"
                    frameBorder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  />
                </div>
              </div>
            </div>
          </TextContainer>
        </Card.Section>
      </Card>
    );
  }
}

const mapStateToProps = (state, props) => ({});

const mapDispatchToProps = dispatch => ({});

export default withBlockCanDismiss(
  connect(mapStateToProps, mapDispatchToProps)(withI18n()(GettingStartedVideos))
);
